<template>
  <header class="header" :class="classes">
    <div class="header__brand">
      <m4-brand-image
        v-if="brandImage"
        :src="brandImage"
        :link="brandLink"
        class="header__brand__image"
      ></m4-brand-image>
      <m4-lang-switcher :langs="langs" :lang-title="langTitle"></m4-lang-switcher>
      <m4-button
        v-if="menuItems.length > 0"
        variant="menu"
        @click="menuOpen = !menuOpen"
        class="header__brand__menu-btn"
        ref="menuBtn"
        :style="menuBtnStyle"
      >
        <m4-menu-icon :menuOpen="menuOpen" variant="ci-primary-contrast"></m4-menu-icon>
      </m4-button>
    </div>
    <div v-if="menuItems.length > 0" class="header__drawer">
      <m4-level v-if="user" class="border-b-300 align-items-center" no-wrap no-gutters>
        <m4-level-left>
          <div class="padding-xl padding-r-none padding-l-none padding-r-lg">
            <m4-icon icon="user" class="header__drawer__user-icon margin-r-md"></m4-icon>
            <span class="header__drawer__user-name">{{ user.name }}</span>
            <div v-if="user.personal_id" class="header__drawer__personal-id">{{ user.personal_id_nice }}</div>
          </div>
        </m4-level-left>
        <m4-level-right class="padding-r-lg">
          <m4-button @click="$emit('logout')" size="sm">
            <m4-icon icon="log-out" class="btn__icon margin-r-sm"></m4-icon>
            {{ $t("logout") }}
          </m4-button>
        </m4-level-right>
      </m4-level>
      <m4-menu :items="menuItems" v-on:menuItemClick="menuOpen = false"></m4-menu>
    </div>
  </header>
</template>

<script>
import inBrowser from "../../../utils/inBrowser.js";

import M4Menu from "../../molecules/menu/menu";
import M4Button from "../../atoms/button/button";

const bodyHeaderDrawerClassName = "body--header-drawer";
const bodyHeaderDrawerOpenClassName = "body--header-drawer-open";

const CLASS_NAME_SCROLLBAR_MEASURER = "header-scrollbar-measure";

export default {
  name: "M4Header",
  components: { M4Button, M4Menu },
  data() {
    return {
      scrollBarWith: null,
      isBodyOverflowing: null,
      menuBtnStyle: {},
      menuOpen: false
    };
  },
  props: {
    brandImage: {
      type: String
    },
    brandTitle: {
      type: String
    },
    brandLink: {
      type: String
    },
    langs: {
      type: Array,
      default() {
        return [];
      }
    },
    langTitle: {
      type: String,
      default() {
        return "Switch to";
      }
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      }
    },
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    logoutUrl: {
      type: String,
      default() {
        return null;
      }
    }
  },
  emit: ["logout"],
  computed: {
    classes() {
      let classes = [];
      if (this.menuOpen) {
        classes.push("header--drawer-open");
      }
      return classes;
    }
  },
  methods: {
    _getScrollbarWidth() {
      // thx d.walsh
      const scrollDiv = document.createElement("div");
      scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      this.scrollBarWith = scrollbarWidth;
      return this.scrollBarWith;
    },
    _isBodyOverflowing() {
      const rect = document.body.getBoundingClientRect();
      return Math.round(rect.top + rect.bottom) > window.innerHeight;
    }
  },
  watch: {
    menuOpen: {
      handler() {
        if (inBrowser()) {
          const body = document.body;
          if (this.menuOpen) {
            if (this._isBodyOverflowing()) {
              body.style.paddingRight = this._getScrollbarWidth() + "px";
              this.menuBtnStyle.marginRight = this._getScrollbarWidth() + "px";
            }
            body.classList.add(bodyHeaderDrawerOpenClassName);
          } else {
            body.style.paddingRight = 0;
            this.menuBtnStyle.marginRight = 0;
            body.classList.remove(bodyHeaderDrawerOpenClassName);
          }
        }
      },
      immediate: true
    },
    $route() {
      this.menuOpen = false;
    }
  },
  created() {
    if (inBrowser()) {
      const body = document.body;
      body.classList.add(bodyHeaderDrawerClassName);
    }
  },
  unmounted() {
    if (inBrowser()) {
      const body = document.body;
      body.classList.remove(bodyHeaderDrawerClassName);
      body.classList.remove(bodyHeaderDrawerOpenClassName);
    }
  }
};
</script>

<style scoped></style>
